<template>
  <WCModal @dismiss="dismiss('Dismissed')">
    <WCModalHeader>
      <h3>{{ $t('editOrderQuestion') }}</h3>
    </WCModalHeader>
    <WCModalBody>
      <p>{{ $t('whenFinishedEditCheckout') }}</p>
    </WCModalBody>
    <WCModalFooter>
      <button @click="close('Order edited')" class="btn btn-outline-primary">
        {{ $t('yesContinue') }}
      </button>
      <button @click="dismiss()" class="btn btn-outline-dark">
        {{ $t('noCancel') }}
      </button>
    </WCModalFooter>
  </WCModal>
</template>

<script>
import ModalMixin from '@/modules/modals/mixins/ModalMixin';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCModalFooter from '@/modules/modals/components/WCModalFooter/WCModalFooter.vue';

export default {
  name: 'WCEditOrderModal',
  mixins: [ModalMixin],
  components: { WCModal, WCModalHeader, WCModalBody, WCModalFooter },
};
</script>
